<template>
  <div class="mt-8">
    <div class="intro-y flex flex-col sm:flex-row items-center">
      <PageHeader class="text-lg font-medium mr-auto" />
    </div>
    <div class="intro-y mt-5 overflow-auto lg:overflow-visible">
      <LoanTable
        :loading="isLoading"
        :rows="loanList"
        :columns="columns"
        :line-numbers="true"
        :sort="sort"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
        @delete="confirmRemoval"
        @onFilter="onFilter"
        @onPageChange="onPageChange"
        @onPerPageChange="onPerPageChange"
        @onSortChange="onSortChange"
      />
    </div>

    <ConfirmDialog :modal-id="deleteModalId" @ok="onDelete" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LOAN_LIST_REQUEST } from '@/store/actions/loan';
import PageHeader from '@/components/ui/PageHeader';
import LoanTable from '@/components/loan/LoanTable';
import dataListMixin from '@/mixins/dataListMixin';

export default {
  mixins: [dataListMixin],

  components: {
    PageHeader,
    LoanTable,
  },

  data() {
    return {
      storeActionListRequest: LOAN_LIST_REQUEST,
      columns: [
        {
          label: this.$t('text.loanNumber'),
          field: 'id',
          sortable: true,
          filterable: true,
        },
        {
          label: this.$t('text.firstName'),
          field: 'firstName',
          filterable: true,
          disabled: true,
        },
        {
          label: this.$t('text.customer'),
          field: 'user',
        },
        {
          label: this.$t('text.registrationNumber'),
          field: 'registrationNumber',
          filterable: true,
          disabled: true,
        },
        {
          label: this.$t('table.phone'),
          field: 'phone',
          filterable: true,
        },
        {
          label: this.$t('text.loanAmount'),
          field: 'amount',
        },
        {
          label: this.$t('text.overdueDays'),
          field: 'overdueDay',
          sortable: true,
        },
        {
          label: this.$t('text.numberOfBankAccount'),
          field: 'bankAccount',
          filterable: true,
        },
        {
          label: this.$t('text.loanFirstOfficer'),
          field: 'firstOfficer',
        },
        {
          label: this.$t('text.loanOfficer'),
          field: 'officer',
        },
        {
          label: this.$t('table.action'),
          field: 'action',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['loanList', 'loanStatus', 'loanMeta']),
    isLoading() {
      return this.loanStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters[`filter[status]`] = 'OVERDUE';
    },

    setPaginationValues() {
      this.totalRecords = this.loanMeta ? this.loanMeta.total : 1;
      this.page = this.loanMeta.currentPage;
      this.totalPage = this.loanMeta.lastPage;
    },
  },
};
</script>
